// extracted by mini-css-extract-plugin
export default {"container":"configurationPage_container__HB2gu","detail":"configurationPage_detail__hnQNf","content":"configurationPage_content__tjb8R","footer":"configurationPage_footer__un22O"};